import { makePostRequest } from 'owa-ows-gateway';

const POST_WEB_PUSH_SUBSCRIPTION_URL: string = 'ows/beta/webpushsubscriptions';

export default async function registerEndpoint(endPoint: OwaPushSubscription): Promise<boolean> {
    return makePostRequest(POST_WEB_PUSH_SUBSCRIPTION_URL, endPoint).then(function(
        response: RegisterEndpointResponse
    ) {
        if (response.registered === true) {
            return Promise.resolve(true);
        } else {
            throw new Error('Failed to register endpoint.');
        }
    });
}
